import { IconPointFilled } from "@tabler/icons-react"
import { Group, ThemeIcon, Text, Tooltip } from "@mantine/core"
import { getLogLevelColor } from "./logLevelFunctions"

export type LogLevel = "Information" | "Warning" | "Error" | "Debug"

interface LogLevelProps {
  value: LogLevel
  withText?: boolean
}

export function LogLevel({ value, withText = false }: LogLevelProps) {
  const logLevelColor = getLogLevelColor(value)
  return (
    <Group gap={"xs"} wrap="nowrap" c={logLevelColor}>
      <Tooltip label={value}>
        <ThemeIcon size={"xs"} c={logLevelColor} variant="transparent">
          <IconPointFilled />
        </ThemeIcon>
      </Tooltip>
      {withText && (
        <Text inherit truncate>
          {value}
        </Text>
      )}
    </Group>
  )
}
